import { render } from "./site_dashboard.vue?vue&type=template&id=33874312&scoped=true"
import script from "./site_dashboard.js?vue&type=script&lang=js"
export * from "./site_dashboard.js?vue&type=script&lang=js"

import "./site_dashboard.vue?vue&type=style&index=0&id=33874312&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33874312"]])

export default __exports__